<template>
  <div class="p-grid p-fluid">
    <div class="p-col-12">
      <div class="card">
        <DataTable
            dataKey="id"
            responsiveLayout="scroll"
            filterDisplay="menu"
            :lazy="true"
            :rows="15"
            :paginator="true"
            :value="referrals.data"
            :totalRecords="referrals.total"
            :rowHover="true"
            :loading="loading"
            @page="query.page = $event.page + 1; getReferrals()"
        >
          <template #header>
            <h2>Referrals</h2>

            <h3>Filtros</h3>

            <!-- Enabled Users Checkbox -->
            <div class="p-d-flex p-flex-row p-justify-between">
              <div class="block field-checkbox p-mt-2 p-flex-column">
                <div class="p-d-flex p-jc-between">
                  <div class="p-d-flex p-jc-end">
                    <span class="p-input-icon-left ">
                      <i class="pi pi-search"/>
                      <InputText v-model="query.search" placeholder="Nombre, email o ig..."/>
                    </span>
                  </div>
                </div>

                <div class="p-d-flex">
                  <div>
                    <div class="p-flex-row p-mb-2 p-mt-4">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <RadioButton id="all" name="all" value="all" v-model="query.reward_type"/>
                      <label for="enabledUsersFilter" class="p-ml-2">
                        Todos
                      </label>
                    </div>
                    <div class="p-flex-row p-mb-2">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <RadioButton id="payment" name="payment" value="balance_credit" v-model="query.reward_type"/>
                      <label for="payment" class="p-ml-2">
                        Referrals de pago
                      </label>
                    </div>
                    <div class="p-flex-row">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <RadioButton id="nonpayment" name="nonpayment" value="free_month_subscription" v-model="query.reward_type"/>
                      <label for="nonpayment" class="p-ml-2">
                        Referrals sin pago
                      </label>
                    </div>
                  </div>
                  <div class="p-pl-2">
                    <div class="p-flex-row p-mb-2 p-mt-4">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <checkbox id="completed" name="completed" value="1" v-model="query.completed"/>
                      <label for="completed" class="p-ml-2">
                        Completados
                      </label>
                    </div>
                    <div class="p-flex-row p-mb-2">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <checkbox id="referrer_is_foodie" name="referrer_is_foodie" value="1" v-model="query.referrer_is_foodie"/>
                      <label for="referrer_is_foodie" class="p-ml-2">
                        Referidor es foodie
                      </label>
                    </div>
                    <div class="p-flex-row p-mb-2">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <checkbox id="referrer_is_restaurant" name="referrer_is_restaurant" value="1" v-model="query.referrer_is_restaurant"/>
                      <label for="referrer_is_restaurant" class="p-ml-2">
                        Referidor es restaurante
                      </label>
                    </div>
<!--                    <div class="p-flex-row p-mb-2">-->
<!--                      &lt;!&ndash;                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>&ndash;&gt;-->
<!--                      <RadioButton id="payment" name="payment" value="balance_credit" v-model="query.reward_type"/>-->
<!--                      <label for="enabledUsersFilter" class="p-ml-2">-->
<!--                        Referrals de pago-->
<!--                      </label>-->
<!--                    </div>-->
<!--                    <div class="p-flex-row">-->
<!--                      &lt;!&ndash;                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>&ndash;&gt;-->
<!--                      <RadioButton id="nonpayment" name="nonpayment" value="free_month_subscription" v-model="query.reward_type"/>-->
<!--                      <label for="enabledUsersFilter" class="p-ml-2">-->
<!--                        Referrals sin pago-->
<!--                      </label>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="p-pt-3">
                  <Button label="Reset filters" class="p-button-sm" @click="resetQueryFilters"/>
                </div>
              </div>
              <div class="p-grid p-fluid p-w-auto" >
                <div class="p-row-2">
                  <h5>Todos</h5>
                  <div v-for="key in getOverviewKeys(overview.all)" :key="key">{{ key + ": " + overview.all[key] }}</div>
                </div>
                <div class="p-row-2 p-mx-4">
                  <h5>Mes actual</h5>
                  <div v-for="key in getOverviewKeys(overview.current_month)" :key="key">{{ key + ": " + overview.current_month[key] }}</div>
                </div>
                <div class="p-row-2">
                  <h5>Año actual</h5>
                  <div v-for="key in getOverviewKeys(overview.current_year)" :key="key">{{ key + ": " + overview.current_year[key] }}</div>
                </div>
              </div>
            </div>
          </template>

<!--          <Column field="id" header="ID"></Column>-->
<!--          <Column field="status" header="Estatus"></Column>-->
          <Column field="referrer.name" header="Referidor"></Column>
          <Column field="referrer.ig_username" header="Referidor IG"></Column>
          <Column field="referred.name" header="Referido"></Column>
          <Column field="referred.ig_username" header="Referido IG"></Column>
          <Column header="Fecha de registro">
            <template #body="{ data }">
              <p>{{ formatDate(data.referred.created_at) }}</p>
            </template>
          </Column>
          <Column header="Fecha pago rest">
            <template #body="{ data }">
              <p v-if="data.referred.type_name === 'restaurant'">{{ formatDate(data.completed_at) }}</p>
              <p v-else></p>
            </template>
          </Column>
          <Column header="Tipo de bono">
            <template #body="{ data }">
              <div v-for="reward in data.rewards" :key="reward" class="">
                <span v-if="reward.amount_e2">{{ reward?.description + ": " + (reward?.amount_e2/100) + (reward?.currency === "eur" ? '€' : '$') }}</span>
                <span v-else>{{ reward?.description }}</span>
              </div>
            </template>
          </Column>
          <Column header="Opciones">
            <template #body="{data}">
              <div v-if="getRevokeCondition(data)">
                <Button
                    type="button" icon="pi pi-cog" class="p-button-rounded p-button-outlined"
                    @click="toggleActionMenu($event, data)" aria-haspopup="true"
                    aria-controls="overlay_menu"/>
                <Menu ref="actionMenu" :model="actionMenuItems" :popup="true"/>
              </div>

            </template>
          </Column>
          <!--            &lt;!&ndash;                    <Column field="client_first_name" header="Nombre"></Column>&ndash;&gt;-->
<!--            &lt;!&ndash;                    <Column field="client_last_name" header="Apellido"></Column>&ndash;&gt;-->
<!--            <Column header="Nombre">-->
<!--              <template #body="{ data }">-->
<!--                <p>{{ data.client_first_name + ' ' + data.client_last_name }}</p>-->
<!--              </template>-->
<!--            </Column>-->
<!--            <Column field="client_phone" header="Teléfono"></Column>-->
<!--            <Column field="client_email" header="Email"></Column>-->
<!--            <Column field="time" header="Hora"></Column>-->
<!--            <Column field="date" header="Fecha"></Column>-->
<!--            <Column field="people_amount" header="Personas"></Column>-->
<!--            <Column field="solo_link_id" header="Vía">-->
<!--              <template #body="{ data }">-->
<!--                <p v-if="data.related_source === 'solo_link'" style="color: #1D9F25">Sololink</p>-->
<!--                <p v-else style="color: #D02222">Colab</p>-->
<!--              </template>-->
<!--            </Column>-->
<!--            &lt;!&ndash;                    <Column header="Estatus">&ndash;&gt;-->
<!--            &lt;!&ndash;                        <template #body="{ data }">&ndash;&gt;-->
<!--            &lt;!&ndash;                            <p>{{ statuses[data.status] }}</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                        </template>&ndash;&gt;-->
<!--            &lt;!&ndash;                    </Column>&ndash;&gt;-->
<!--            <Column header="Estatus Covermanager">-->
<!--              <template #body="{ data }">-->
<!--                <p>{{ providerStatuses[data.provider_status] }}</p>-->
<!--              </template>-->
<!--            </Column>-->

          <template #empty>
            No se encontraron rewards
          </template>
          <template #loading>
            Cargando...
          </template>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>

import { useRepository } from "@/hooks";
import {onMounted, ref, watch} from "vue";
import moment from "moment/moment";

export default {
  name: 'referrals',
  setup () {
    const repository = useRepository(({ referrals }) => (referrals))
    const referrals = ref({})
    const loading = ref(false)
    const query = ref({
      'limit': 15,
      'paginate': true,
      'page': 1,
      'reward_type': 'all'
    })
    const actionMenu = ref(null);
    const selectedReward = ref({})
    const actionMenuItems = ref([])
    const searchDebounce = ref(null)
    const overview = ref({})

    const getReferrals = () => {
      loading.value = true
      const $0 = { ...query.value}

      if (query.value.reward_type === 'all') {
        delete $0.reward_type
      }
      repository.list($0)
          .then(({ data: resp }) => {
            referrals.value = resp
          })
          .finally(() => loading.value = false)
    }

    const getOverview = () => {
      repository.overview(query.value)
          .then(({ data: resp }) => {
            overview.value = resp
          })
    }

    const revokeReward = (data) => {
      repository.revoke(data?.rewards[0].id)
          .then(({ data: resp }) => {
            overview.value = resp
            this.$toast.add({ severity: 'success', summary: `Se ha revocado este reward.`, life: 5000 })
            getReferrals()
          })
    }

    const getRevokeCondition = (data) => {
      return (data?.rewards[0]?.reward_type === "balance_credit" && data?.rewards[0]?.revoked_at === null )
    }

    const toggleActionMenu = (event, reward) => {
      selectedReward.value = reward;

      actionMenuItems.value = [
        {
          label: 'Revoke',
          command: () => {
            revokeReward(reward)
          }
        }
      ]
      actionMenu.value.toggle(event)
    }

    const formatDate = (date) =>  {
      if (date) {
        return moment(date).format('YYYY-MM-D')
      } else {
        return ''
      }
    }

    const getOverviewKeys = (values) => {
      if (values) {
        return Object.keys(values)
      } else {
        return []
      }
    }

    const resetQueryFilters = () => {
      query.value = {
        'limit': 15,
        'paginate': true,
        'page': 1,
        'reward_type': 'all'
      }
    }

    watch(() => query.value.reward_type, () => {
      getReferrals()
    })

    watch(() => query.value.completed, () => {
      getReferrals()
    })

    watch(() => query.value.referrer_is_foodie, () => {
      getReferrals()
    })

    watch(() => query.value.referrer_is_restaurant, () => {
      getReferrals()
    })

    watch(() => query.value.search, (newVal) => {
      if (newVal === null) {
        return;
      }

      if (searchDebounce.value) {
        clearTimeout(searchDebounce.value)
      }

      searchDebounce.value = setTimeout(() => {
        if (newVal === '') {
          query.value = { ...query.value, limit: 15, paginate: true, page: 1 }
        }
        getReferrals()
      }, 600)
    })

    onMounted(() => {
      getReferrals()
      getOverview()
    })

    return {
      referrals,
      query,
      loading,
      actionMenuItems,
      actionMenu,
      overview,
      resetQueryFilters,
      getOverviewKeys,
      formatDate,
      toggleActionMenu,
      getRevokeCondition,
      getReferrals
    }
  }
}
</script>

<style scoped>

</style>